import React from "react";
import PropTypes from "prop-types";
import {StyledTextArea} from "./styles";

const TextArea = props => {
    const {maxLength, onChange} = props;

    return <StyledTextArea
        contentEditable
        role="textbox"
        // @ts-ignore
        onInput={e => onChange(e.target.innerText)}
        onPaste={maxLength ? (e => {
            if(e.clipboardData.getData('Text').length > maxLength) {
                e.preventDefault();
            }
        }) : undefined}
        onKeyPress={maxLength ? (e => {
            // @ts-ignore
            if(e.target.innerText.length > maxLength) {
                e.preventDefault();
            }
        }) : undefined}
    />

}

TextArea.propTypes = {
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
}

export default TextArea;
